import type { FC } from "react";
import type { ChatChannelName } from "../../../channels/types";
import {
  LexicalSlackMomentForm,
  LexicalTeamsMomentForm,
} from "../../../lexical-chat-moment/chat-moment-form";
import type { Tags } from "../../../merge-tag/types";

interface ChatEditorSelectProps {
  chatChannel: ChatChannelName;
  mergeTags: Tags;
  disabled: boolean;
  isSubmitted: boolean;
}

export const ChatEditorSelect: FC<ChatEditorSelectProps> = ({
  chatChannel,
  mergeTags,
  disabled,
  isSubmitted,
}) => {
  return chatChannel === "slack" ? (
    <LexicalSlackMomentForm
      disabled={disabled}
      mergeTags={mergeTags}
      showValidationErrors={isSubmitted}
    />
  ) : (
    <LexicalTeamsMomentForm
      disabled={disabled}
      mergeTags={mergeTags}
      showValidationErrors={isSubmitted}
    />
  );
};
